<template src="./RiskSkeleton.html"></template>

<script>
import { RISK_LONG_WAIT_HINT_MS } from "@/config/riskConfig";

export default {
  name: "RiskSkeleton",
  props: {
    presentation: { type: Object, default: null },
    lat: { type: Number, default: null },
    lon: { type: Number, default: null },
  },
  data() {
    return {
      // Alternating heights for a plausible-looking bar skeleton — purely
      // decorative, unrelated to any real data.
      barHeights: [55, 46, 37, 28, 21, 16, 12, 8, 5, 3, 1],
      longWait: false,
    };
  },
  computed: {
    statusLine() {
      const noun = this.loadingNoun;
      if (this.lat != null && this.lon != null) {
        return `Counting ${noun} at ${this.lat}, ${this.lon}…`;
      }
      return `Counting ${noun}…`;
    },
    loadingNoun() {
      return (this.presentation && this.presentation.loadingNoun) || "the historical record";
    },
  },
  mounted() {
    // The probability endpoint gets two minutes (riskConfig.js); a skeleton that
    // never changes over that long reads as a hung request, which is exactly the
    // confusion the old 15s timeout error caused. Risk.html re-keys this
    // component per request, so the countdown restarts with each one.
    this.longWaitTimer = setTimeout(() => {
      this.longWait = true;
    }, RISK_LONG_WAIT_HINT_MS);
  },
  // NOT beforeUnmount — this app runs Vue 2.6, which ignores that hook name
  // entirely. Same reasoning (and the same misfiring vue3-essential rule) as
  // Risk.vue's ResizeObserver teardown.
  // eslint-disable-next-line vue/no-deprecated-destroyed-lifecycle
  beforeDestroy() {
    clearTimeout(this.longWaitTimer);
  },
};
</script>

<style lang="scss" src="./RiskSkeleton.scss"></style>
